async function afterLoginAction (that) {
  try {
    await that.$axios.put('/private/user-action/login', {})
  } catch (e) {
    console.error(e)
  }

  const url = '/private/after/login/action/get'

  const token = that.$auth.strategy.token.get()

  const {
    data,
    status
  } = await that.$axios.get(url, {
    headers: { Authorization: token },
    withCredentials: true
  })

  if (status === 200) {
    await that.$axios.post('/private/product/take-ownership', {}, { withCredentials: true })

    if (data.length === 0) {
      await that.$router.push(that.localePath({ name: 'index' }))
    } else {
      for (let index = 0; index < data.length; index++) {
        const action = data[index]

        try {
          switch (action.method) {
            case 'redirect': {
              await that.$router.push(that.localePath(action.route))
              break
            }
            case 'post': {
              let payload = action.payload
              if (payload === null || payload === undefined) {
                payload = {}
              }
              await that.$axios.post(action.route.name, payload, { withCredentials: true })
              break
            }
            case 'delete':
              if (!action.route.name.includes('undefined')) {
                await that.$axios.delete(action.route.name, {})
              }

              if (action.id) {
                await that.$axios.delete(`/private/after/login/action/delete/${action.id}`, {})
              }

              break
            case 'get': {
              await that.$axios.get(action.route.name)
              break
            }
            default:
              break
          }
        } catch
        (e) {
          console.error(e)
        }
      }

      await that.$axios.delete('/private/after/login/action/delete-all', { withCredentials: true })
    }
  }
  // else {
  //   await that.$router.push(that.localePath({ name: 'index' }))
  // }
}

function tapfiliateLogNewRegistration (that, customerId) {
  try {
    const registration = that.$auth.user['http://cm24.de/registration']
    if (registration) {
      const now = new Date().getTime()
      if (now < registration + 60 * 1000) {
        that.$tapfiliate.customer(
          customerId,
          that.$auth.user.email
        )
      }
    }
  } catch (e) {
    console.error(e)
  }
}

function gtmLogNewRegistration (that, customerId) {
  try {
    const registration = that.$auth.user['http://cm24.de/registration']
    that.$gtm.push({
      customerId,
      customerEmail: that.$auth.user.email
    })

    if (registration) {
      const now = new Date().getTime()
      if (now < registration + 60 * 1000) {
        that.$gtm.push({
          event: 'register',
          auth0UserId: that.$auth.user.sub,
          customerId
        })
      }
    } else {
      that.$gtm.push({
        event: 'login',
        auth0UserId: that.$auth.user.sub,
        customerId
      })
    }
  } catch (e) {
    console.error(e)
  }
}

const afterLoginActions = {
  afterLoginAction,
  tapfiliateLogNewRegistration,
  gtmLogNewRegistration

}

export default afterLoginActions
